import React from "react";
import locationbottom from "../../assets/images/Icons_and_images/location bottom.png";
import mobilebottom from "../../assets/images/Icons_and_images/mobile bottom.png";
import timebottom from "../../assets/images/Icons_and_images/time bottom.png";
import mail from "../../assets/images/Icons_and_images/mail.png";
import facebook from "../../assets/images/Icons_and_images/facebook.png";
import whatsapp from "../../assets/images/Icons_and_images/whatsapp.png";
import firstf from "../../assets/images/Icons_and_images/image-1.jpg";
import secondf from "../../assets/images/Icons_and_images/project-2.jpg";
import thirdf from "../../assets/images/Icons_and_images/project-3.jpg";
import fourth from "../../assets/images/Icons_and_images/project-1.jpg";
import bricklogo from "../../assets/images/Icons_and_images/logo.jpg";
import sarasulogo from "../../assets/images/SARASU_LOGO_SVG.svg";
import AIS1 from "../../assets/images/AIS Logo.png";
import "@fontsource/manrope";
import "@fontsource/syne";
import { FaClock } from "react-icons/fa";
import { BiMobile } from "react-icons/bi";
import { FaLocationPin } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { CiClock1 } from "react-icons/ci";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/Aboutus" },
  { label: "Contact Us", href: "/Contactus" },
];

function Footer() {
  return (
    <footer style={{ fontFamily: "'Manrope', sans-serif" }}>
      {/* ── Main footer body ── */}
      <div
        style={{
          background: "#fff",
          borderTop: "1px solid rgba(0,0,0,0.08)",
          padding: "3rem 0 2.5rem",
        }}
      >
        <div className="container" style={{ maxWidth: 1100 }}>
          <div className="row g-5 align-items-start">
            {/* Logo + tagline */}
            <div className="col-md-3 text-center">
              <img
                src={AIS1}
                alt="Athees Info Solutions"
                style={{
                  height: 120,
                  width: "auto",
                  objectFit: "contain",
                  marginBottom: ".5rem",
                }}
              />
            </div>
            <div className="col-12 col-md-3">
              <p
                style={{
                  fontSize: "0.875rem",
                  color: "#666",
                  lineHeight: 1.75,
                  maxWidth: 260,
                  marginTop: "15px",
                }}
              >
                Transforming businesses with cutting-edge technology solutions
                across the globe.
              </p>
            </div>

            {/* Navigation */}
            <div className="col-6 col-md-3">
              <p
                style={{
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                  color: "#563D7C",
                  marginBottom: "1rem",
                }}
              >
                Company
              </p>
              <ul
                className="list-unstyled mb-0"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.65rem",
                }}
              >
                {navLinks.map(({ label, href }) => (
                  <li key={href}>
                    <a
                      href={href}
                      style={{
                        fontSize: "0.875rem",
                        color: "#444",
                        textDecoration: "none",
                        transition: "color 0.18s",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.color = "#563D7C")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.color = "#444")
                      }
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact info */}
            <div className="col-12 col-md-3">
              <p
                style={{
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                  color: "#563D7C",
                  marginBottom: "1rem",
                }}
              >
                Contact
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.75rem",
                }}
              >
                {[
                  // {
                  //   icon: <FaLocationPin />,
                  //   text: "Madurai - 625002, Tamil Nadu, India",
                  // },
                  { icon: <BiMobile />, text: "+91 99941 74786" },
                  { icon: <MdEmail />, text: "aathees@aathes.com" },
                  { icon: <CiClock1 />, text: "Mon – Sat, 9:30 AM – 6:30 PM" },
                ].map(({ icon, text }) => (
                  <div
                    key={text}
                    style={{ display: "flex", alignItems: "center", gap: 10 }}
                  >
                    <span
                      style={{
                        fontSize: "18px",
                        opacity: 0.8,
                        display: "flex",
                        alignItems: "center",
                        color: "#0d6efd",
                      }}
                    >
                      {icon}
                    </span>
                    <span style={{ fontSize: "0.825rem", color: "#555" }}>
                      {text}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Social */}
            {/* <div className="col-6 col-md-12 col-lg-3">
              <p
                style={{
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                  color: "#563D7C",
                  marginBottom: "1rem",
                }}
              >
                Follow Us
              </p>
              <div style={{ display: "flex", gap: 10 }}>
                {[
                  { icon: facebook, href: "#", label: "Facebook" },
                  { icon: whatsapp, href: "#", label: "WhatsApp" },
                ].map(({ icon, href, label }) => (
                  <a
                    key={label}
                    href={href}
                    aria-label={label}
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 10,
                      border: "1px solid rgba(86,61,124,0.15)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "#faf8fd",
                      transition:
                        "background 0.2s, border-color 0.2s, transform 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#563D7C";
                      e.currentTarget.style.borderColor = "#563D7C";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "#faf8fd";
                      e.currentTarget.style.borderColor =
                        "rgba(86,61,124,0.15)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <img
                      src={icon}
                      alt={label}
                      width={18}
                      height={18}
                      style={{ objectFit: "contain" }}
                    />
                  </a>
                ))}
              </div>
            </div> */}
          </div>
        </div>
      </div>

      {/* ── Copyright bar ── */}
      <div style={{ background: "#31299e", padding: "0.9rem 1rem" }}>
        <p
          style={{
            margin: 0,
            textAlign: "center",
            color: "rgba(255,255,255,0.8)",
            fontSize: "0.78rem",
            letterSpacing: "0.02em",
          }}
        >
          © 2026 Athees Info Solutions, Inc. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
